export default "__VITE_ASSET__MCa3DtRd__"